import { render, staticRenderFns } from "./CalendarDash.vue?vue&type=template&id=54899311"
import script from "./CalendarDash.vue?vue&type=script&lang=js"
export * from "./CalendarDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports